import { Icon } from "@chakra-ui/react"

export const SpreadsheetIcon = (props: any) => (
  <Icon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 93.66 104.93">
    <g id="Group_1671" transform="translate(0 0)">
      <g id="Group_1621">
        <g id="Group_1620">
          <path id="Path_721" d="M78.75,33.15L55.96,10.36c-0.32-0.32-0.76-0.5-1.21-0.5H22.64c-3.9,0.01-7.06,3.17-7.07,7.07v72.48
            c0,3.9,3.17,7.07,7.07,7.07h49.55c3.9,0,7.07-3.17,7.07-7.07V34.36C79.26,33.9,79.08,33.47,78.75,33.15z M56.47,15.7l16.94,16.94
            H60.11c-2.01,0-3.65-1.63-3.65-3.65V15.7z M75.83,89.41c0,2.01-1.63,3.65-3.65,3.65H22.63c-2.01,0-3.65-1.63-3.65-3.65V16.93
            c0-2.01,1.63-3.65,3.65-3.65h30.38V29c0,3.91,3.17,7.08,7.08,7.07c0,0,0.01,0,0.01,0h15.71V89.41z"/>
        </g>
      </g>
      <g id="Group_1623" transform="translate(6.191 15.759)">
        <g id="Group_1622" transform="translate(0)">
          <path id="Path_722" d="M54.4,37.24H28.04c-0.94,0-1.71,0.77-1.71,1.71v22.94c0,0.94,0.77,1.71,1.71,1.71H54.4
            c0.94,0,1.71-0.77,1.71-1.71V38.95C56.11,38,55.35,37.24,54.4,37.24z M29.75,40.66h9.76v4.16h-9.76V40.66z M39.51,60.18h-9.76
            v-4.16h9.76V60.18z M39.51,52.59h-9.76v-4.35h9.76V52.59z M52.69,60.18h-9.76v-4.16h9.76L52.69,60.18z M52.69,52.59h-9.76v-4.35
            h9.76L52.69,52.59z M52.69,44.82h-9.76v-4.16h9.76L52.69,44.82z"/>
        </g>
      </g>
    </g>
  </Icon>
);
